import React from 'react'
import { Copy as CopyIcon } from 'react-feather'
import PropTypes from 'prop-types'
import { Box, IconButton, Paper, Typography } from '@material-ui/core'

import useClipboard from 'hooks/useClipboard'

import theme from 'theme'
import useStyles from './styles'

import { getBaseCookiesCdnUrl, isDevelopment } from 'service/env'

const BannerCode = ({ bannerToken }) => {
  const classes = useStyles()
  const { copy } = useClipboard()

  const baseCookiesCdnUrl = getBaseCookiesCdnUrl()
  const divCode = '<div id="dpoeasy-banner">'
  const scriptCode = `<script src="${baseCookiesCdnUrl}${
    !isDevelopment ? `/banners/${bannerToken}/banner.js` : ''
  }"></script></div>`

  const handleCodeCopying = () => copy(`${divCode}\n${scriptCode}`)

  return (
    <Box display="flex" flexDirection="column" gridGap={theme.spacing(2)}>
      <Box>
        <Typography color="primary" variant="h6" gutterBottom>
          Código HTML de instalação do banner
        </Typography>
      </Box>
      <Paper variant="outlined">
        <Box bgcolor={theme.palette.background.default}>
          <Box display="flex" justifyContent="space-between">
            <Typography variant="body2" className={classes.divCodeTypography}>
              {divCode}
            </Typography>
            <Box height="fit-content">
              <IconButton
                size="small"
                className={classes.iconButton}
                onClick={handleCodeCopying}
              >
                <CopyIcon size={18} color={theme.palette.custom.superDark} />
              </IconButton>
            </Box>
          </Box>
          <Typography variant="body2" className={classes.scriptCodeTypography}>
            {scriptCode}
          </Typography>
        </Box>
      </Paper>
    </Box>
  )
}

BannerCode.propTypes = {
  bannerToken: PropTypes.string,
}

export default BannerCode
